// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IUpdateProcessingRuleTierDto } from './IUpdateProcessingRuleTierDto';
import {
    IUpdateProcessingRuleTierDtoFromJSON,
    IUpdateProcessingRuleTierDtoFromJSONTyped,
    IUpdateProcessingRuleTierDtoToJSON,
    IUpdateProcessingRuleTierDtoToJSONTyped,
} from './IUpdateProcessingRuleTierDto';

/**
 * 
 * @export
 * @interface IUpdateProcessingRuleTiersDto
 */
export interface IUpdateProcessingRuleTiersDto {
    /**
     * 
     * @type {Array<IUpdateProcessingRuleTierDto>}
     * @memberof IUpdateProcessingRuleTiersDto
     */
    tiers: Array<IUpdateProcessingRuleTierDto>;
}

/**
 * Check if a given object implements the IUpdateProcessingRuleTiersDto interface.
 */
export function instanceOfIUpdateProcessingRuleTiersDto(value: object): value is IUpdateProcessingRuleTiersDto {
    if (!('tiers' in value) || value['tiers'] === undefined) return false;
    return true;
}

export function IUpdateProcessingRuleTiersDtoFromJSON(json: any): IUpdateProcessingRuleTiersDto {
    return IUpdateProcessingRuleTiersDtoFromJSONTyped(json, false);
}

export function IUpdateProcessingRuleTiersDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IUpdateProcessingRuleTiersDto {
    if (json == null) {
        return json;
    }
    return {
        
        'tiers': ((json['tiers'] as Array<any>).map(IUpdateProcessingRuleTierDtoFromJSON)),
    };
}

export function IUpdateProcessingRuleTiersDtoToJSON(json: any): IUpdateProcessingRuleTiersDto {
    return IUpdateProcessingRuleTiersDtoToJSONTyped(json, false);
}

export function IUpdateProcessingRuleTiersDtoToJSONTyped(value?: IUpdateProcessingRuleTiersDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tiers': ((value['tiers'] as Array<any>).map(IUpdateProcessingRuleTierDtoToJSON)),
    };
}

